import { Link } from "react-router";

import { ArrowLeftIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { toHumanErrorMessage } from "@/lib/extensions/httpErrorExtension";

/** Where a group page sends a curator back to: the Groups only view of `/events`. */
export const GROUPS_VIEW = "/events?view=groups";

export function BackLink() {
  return (
    <Button asChild variant="ghost" size="sm" className="-ml-2.5 w-fit">
      <Link to={GROUPS_VIEW}>
        <ArrowLeftIcon className="size-4" />
        Back to event groups
      </Link>
    </Button>
  );
}

export function GroupLoading() {
  return <div className="p-6 text-sm text-muted-foreground">Loading…</div>;
}

export function GroupGone() {
  return (
    <div className="p-6">
      <div className="mx-auto flex max-w-5xl flex-col gap-3">
        <h1 className="text-2xl font-bold">
          This group does not exist any more
        </h1>
        <p className="text-sm text-muted-foreground">
          It may have been deleted since you opened this link.
        </p>
        <BackLink />
      </div>
    </div>
  );
}

export function GroupLoadFailed({
  error,
  onRetry,
}: {
  error: unknown;
  onRetry: () => void;
}) {
  return (
    <div className="p-6">
      <div className="mx-auto flex max-w-5xl flex-col gap-3">
        <BackLink />
        <div className="flex items-center gap-3 text-sm text-destructive">
          <span>
            {toHumanErrorMessage(error) || "Could not load this group."}
          </span>
          <Button variant="outline" size="sm" onClick={onRetry}>
            Retry
          </Button>
        </div>
      </div>
    </div>
  );
}
